import FormRemunaciones from "./FormPrincipal";

export default function EditRemunacion() {
    return (
        <FormRemunaciones data={JSON.parse(localStorage.getItem("calc3rem"))}/>
    )
}